
export const headersParceiro = {
    diagnosticos_detalhados: [
        { text: 'UF', value: 'uf', align: 'start' },
        { text: 'Unidade Regional', value: 'nomeRegiao' },
        { text: 'Parceiro', value: 'nome' },
        { text: 'Situação', value: 'situacao' }
    ],
    situacao_detalhada_envio_evidencia: [
        { text: 'Regional', value: 'nomeRegiao', align: 'start' },
        { text: 'Parceiro', value: 'municipioNome', align: 'start' },
        { text: 'Pilar', value: 'nomeTema', align: 'start' },
        { text: 'Critério', value: 'texto', align: 'start' },
        { text: 'Arquivos Enviados', value: 'arquivosEnviados', align: 'start' },
        { text: 'Arquivos em Análise', value: 'arquivosAnalise', align: 'start' },
        { text: 'Arquivos Aprovados', value: 'arquivosAprovados', align: 'start' },
        { text: 'Arquivos Rejeitados', value: 'arquivosREjeitados', align: 'start' },
        { text: 'Pontos Possíveis', value: 'pontosPossiveis', align: 'start' },
        { text: 'Pontos Obtidos', value: 'pontosObtidos', align: 'start' },
    ]

}